import PostSegment from './PostSegment';

export default PostSegment;
